export const TAROT_LUNARA = [
  {
    id: "tl001",
    metin: "{{ad}}, kartların sana bugün çok net bir mesaj veriyor. {{soru}} konusunda geçmişte bıraktığın bir şey var — tam anlamıyla bırakılmamış. Şimdinin enerjisi o geçmişin ağırlığını taşıyor. Gelecek ise bekliyor — sabırla, umutla.\n\nKartlar diyor ki: bırakmayı öğrendiğinde, gelecek kendiliğinden açılacak. Bırakmak yenilmek değil — seçmektir. Geçmişi bırakarak geleceği seçiyorsun.",
    tema: "birakma"
  },
  {
    id: "tl002",
    metin: "{{ad}}, üç kartın birlikte anlattığı hikaye ilginç. {{soru}} konusunda geçmişte verilen bir karar, şimdiki durumu şekillendirmiş. Ama gelecek kartı umut veriyor — bu kararın sonuçları değişebilir.\n\nElinde olan seçimler var. Onları kullan. Geçmişin kararları seni bugüne getirdi — bugünün kararları seni yarına götürecek.",
    tema: "karar"
  },
  {
    id: "tl003",
    metin: "{{ad}}, kartların enerjisi bugün çok yoğun. {{soru}} konusunda geçmişte bir kayıp var — belki bir insan, belki bir fırsat, belki bir parça kendin. Şimdi o kaybın yasını tutuyorsun.\n\nGelecek ise yenilenmeyi gösteriyor. Yas biter, yenilenme başlar. Ve yenilenme, kayıptan önce olan halinden çok daha güçlü bir versiyonunu getirir.",
    tema: "kayip_ve_yenilenme"
  },
  {
    id: "tl004",
    metin: "{{ad}}, kartları çevirirken bir sıcaklık hissettim. {{soru}} için şunu söyleyeyim: geçmişte ekilmiş tohumlar şimdi filizleniyor. Henüz göremeyebilirsin — ama toprak altında bir hareket var.\n\nGelecek o filizin büyüyeceğini gösteriyor. Sulamaya devam et. Göremediğin şeyler büyümüyor değil — sadece henüz gün yüzüne çıkmadı.",
    tema: "buyume"
  },
  {
    id: "tl005",
    metin: "{{ad}}, bu üç kart bana bir yolculuk anlatıyor. {{soru}} konusunda geçmişte başlayan bir yolculuk var — içsel bir yolculuk. Şimdi o yolculuğun ortasındasın — yorulmuş, belki kaybolmuş hissediyorsun.\n\nAma gelecek kartı diyor ki: yol devam ediyor ve güzel bir yere çıkıyor. Yolun ortasında kaybolmuş hissetmek normal — bu kayboluş aslında derinleşmedir.",
    tema: "yolculuk"
  },
  {
    id: "tl006",
    metin: "{{ad}}, kartların dizilişi ilginç bir desen oluşturdu. {{soru}} konusunda geçmişte güçlü bir bağ var — kopmamış, sadece gerilmiş. Şimdi o gerginlik dorukta.\n\nGelecek ise ya çözülmeyi ya da kopuşu gösteriyor. Hangi olasılık gerçekleşir? Bu seçim sende. Ve her iki seçim de bir cevaptır — doğru olan senin için doğru olan.",
    tema: "bag"
  },
  {
    id: "tl007",
    metin: "{{ad}}, kartlar bugün sana dürüst bir ayna tutuyor. {{soru}} konusunda geçmişte bir kaçış var — bir şeyden, bir durumdan, belki kendinden. Şimdi o kaçışın sonuna geldin.\n\nGelecek ise yüzleşmenin ardından gelen huzuru gösteriyor. Yüzleşmek o kadar da korkunç değil — korku, yüzleşmeden önce en büyük, yüzleştikten sonra en küçük.",
    tema: "yuzlesme"
  },
  {
    id: "tl008",
    metin: "{{ad}}, bu kartlar bana bir dönüşüm hikayesi anlatıyor. {{soru}} konusunda geçmişte olan sen ile şimdiki sen farklı insanlar. Bu dönüşüm acı vermiş olabilir.\n\nAma gelecek kartı söylüyor: bu dönüşüm seni daha güçlü, daha derin, daha gerçek kıldı. Dönüşümün bedeli vardır — ama kazancı daha büyüktür.",
    tema: "donusum"
  },
  {
    id: "tl009",
    metin: "{{ad}}, kartların enerjisi bugün çok berrak. {{soru}} için şunu söyleyeyim: geçmişte bir fırsat kaçmış — ya da kaçmış gibi hissettiren bir şey. Şimdi pişmanlık var belki.\n\nAma gelecek kartı diyor ki: o kapı kapandı ama yeni bir kapı açılmak üzere. Gözünü aç. Kapalı kapılara bakma — açık olan kapıya bak.",
    tema: "firsat"
  },
  {
    id: "tl010",
    metin: "{{ad}}, üç kartın birlikte yarattığı enerji beni şaşırttı. {{soru}} konusunda geçmiş, şimdi ve gelecek birbirine çok bağlı — neredeyse tek bir hikaye gibi.\n\nBu bağlantı şunu söylüyor: şu an yaşadıkların tesadüf değil, bir hazırlık. Neye hazırlandığını yakında anlayacaksın. Ve o an geldiğinde her şey yerli yerine oturacak.",
    tema: "hazirlık"
  },
  {
    id: "tl011",
    metin: "{{ad}}, kartlar bugün sana cesaret mesajı gönderiyor. {{soru}} konusunda geçmişte cesaretsizlik var — alınmamış riskler, söylenmemiş sözler. Şimdi o cesaretsizliğin bedeli ödeniyor.\n\nAma gelecek diyor ki: cesur ol, bir adım at. O adım her şeyi değiştirebilir. Cesaret bir kez gösterildiğinde, bir sonraki sefer daha kolay gelir.",
    tema: "cesaret"
  },
  {
    id: "tl012",
    metin: "{{ad}}, kartların dili bugün çok şiirsel. {{soru}} için şunu görüyorum: geçmişte bir güzellik var — belki unutulmuş, belki görmezden gelinmiş. Şimdi o güzelliği özlüyorsun.\n\nGelecek diyor ki: o güzellik geri gelebilir — ama farklı bir formda. Hazır ol. Güzellik döner — bazen aynı yüzle, bazen yeni bir kılıkla.",
    tema: "guzellik"
  },
  {
    id: "tl013",
    metin: "{{ad}}, bu kartlar bana sınırlardan bahsediyor. {{soru}} konusunda geçmişte çizilmemiş sınırlar var. Şimdi o sınırsızlık seni yoruyor, tüketiyor.\n\nGelecek kartı şunu söylüyor: sınır çizmek sevgisizlik değil, öz saygıdır. Çiz o sınırı. Sınır çeken insan hem kendini hem de karşısındakini korur.",
    tema: "sinir"
  },
  {
    id: "tl014",
    metin: "{{ad}}, kartların enerjisi bugün biraz melankoli taşıyor. {{soru}} konusunda bir üzüntü var — geçmişte kalan bir şey için. Bu üzüntüyü taşımak normal.\n\nAma gelecek ise hafifliği gösteriyor. Taşımak ile yük altında ezilmek farklı şeyler. Üzüntüyü kabul et, yas tut, sonra bırak. Hafiflik bir ödül değil — bir seçim.",
    tema: "hafiflesme"
  },
  {
    id: "tl015",
    metin: "{{ad}}, kartlar bugün sana umut mesajı getiriyor. {{soru}} konusunda geçmişte karanlık bir dönem var. Şimdi hâlâ o karanlığın içindesin belki.\n\nAma gelecek kartı — çok net görüyorum — ışık gösteriyor. Karanlık geçici, ışık kalıcı. Ve o ışık dışarıdan gelmeyecek — içinden doğacak.",
    tema: "umut"
  },
  {
    id: "tl016",
    metin: "{{ad}}, bu üç kartın hikayesi beni etkiledi. {{soru}} için şunu söyleyeyim: geçmişte verilen emekler şimdi meyvelerini vermeye başlıyor. Göremeyebilirsin henüz — ama süreç işliyor.\n\nGelecek kartı hasat zamanını gösteriyor. Sabret. Emek hiçbir zaman boşa gitmez — sadece bazen gecikmeli gelir.",
    tema: "emek_ve_meyve"
  },
  {
    id: "tl017",
    metin: "{{ad}}, kartlar bugün ilişkilerden bahsediyor. {{soru}} konusunda geçmişte bir ilişki — aşk mı, dostluk mu, aile mi bilmiyorum — seni derinden etkilemiş. Şimdi o etkiyle yaşıyorsun.\n\nGelecek ise yeni bir bağı gösteriyor — daha sağlıklı, daha dengeli. Eski bağın izleri silinmez — ama yeni bağ onların üzerine kurulur, daha sağlam.",
    tema: "iliski"
  },
  {
    id: "tl018",
    metin: "{{ad}}, kartların dizilişi bana güç hikayesi anlattı. {{soru}} konusunda geçmişte bir güçsüzlük hissi var — kontrol edemediğin bir durum. Şimdi hâlâ o his devam ediyor belki.\n\nAma gelecek kartı diyor ki: güç sende her zaman vardı. Sadece görmüyordun. Güç dışarıdan verilmez — içeriden keşfedilir.",
    tema: "guc"
  },
  {
    id: "tl019",
    metin: "{{ad}}, kartlar bugün değişimden bahsediyor. {{soru}} konusunda geçmişte bir değişime direnç var. Şimdi o direnç yoruyor.\n\nGelecek kartı şunu söylüyor: değişimi kabul ettiğinde, hayat çok daha kolay akacak. Direnmek enerji harcar, kabul etmek enerji verir. O enerjiyi değişime direnmeye değil, değişimi yönetmeye harca.",
    tema: "degisim"
  },
  {
    id: "tl020",
    metin: "{{ad}}, bu kartlar bana içsel bir ses hakkında konuşuyor. {{soru}} konusunda geçmişte o içsel sesi bastırmışsın. Şimdi o ses daha yüksek çıkıyor — görmezden gelemiyorsun.\n\nGelecek diyor ki: o sesi dinlediğinde, doğru yola giriyorsun. İçsel ses nadiren yanılır — onu bastıran dış sesler yanılır.",
    tema: "ic_ses"
  },
  {
    id: "tl021",
    metin: "{{ad}}, kartların enerjisi bugün çok dengeli. {{soru}} konusunda geçmiş, şimdi ve gelecek arasında bir denge var — nadir görülen bir şey bu.\n\nBu denge şunu söylüyor: doğru yoldasın. Büyük değişimlere gerek yok. Devam et. Bazen en cesur eylem, durduğun yerde devam etmektir.",
    tema: "denge"
  },
  {
    id: "tl022",
    metin: "{{ad}}, kartlar bugün sana bir hediye getiriyor. {{soru}} için şunu görüyorum: geçmişte yaşanan zorluklar sana beklenmedik bir hediye vermiş — dayanıklılık, empati, derinlik.\n\nŞimdi o hediyin farkında mısın? Gelecek onu kullanmayı gösteriyor. Zorlukların verdiği hediyeler en kalıcı olanlardır.",
    tema: "hediye"
  },
  {
    id: "tl023",
    metin: "{{ad}}, kartlar bugün sana bir soru soruyor. {{soru}} konusunda şunu sormak istiyorum: gerçekten ne istiyorsun? Başkalarının beklentisi değil, senin gerçek isteğin.\n\nKartlar diyor ki: o gerçek isteği bildiğinde, yol kendiliğinden açılıyor. Gerçek istek pusuladır — onu bulduktan sonra kaybolmazsın.",
    tema: "gercek_istek"
  },
  {
    id: "tl024",
    metin: "{{ad}}, bu üç kartın enerjisi beni sarstı biraz. {{soru}} konusunda çok güçlü bir enerji var — kullanılmamış, bekleyen bir potansiyel. Geçmişte o potansiyeli görmezden geldin. Şimdi uyanıyor.\n\nGelecek onu hayata geçirmeyi gösteriyor. Hazır mısın? Potansiyel gerçekleşmeyi bekler — onu harekete geçiren sensin.",
    tema: "potansiyel"
  },
  {
    id: "tl025",
    metin: "{{ad}}, kartlar şunu fısıldıyor: her şey tam zamanında gerçekleşiyor. {{soru}} konusunda sabırsızlanma, endişelenme, zorlanma.\n\nGeçmiş seni buraya getirdi, şimdi seni hazırlıyor, gelecek seni karşılıyor. Güven — hem kendine hem de sürece. Zamanlaması mükemmel olan bir evren var — ve sen onun içindesin.",
    tema: "guven"
  }
];